module.exports = __webpack_public_path__ + "img/chat-file.2b993f06.svg";